import { Typography } from "@mui/material"

const TypoTitle = ({title}) => {

    return <Typography
      variant="h3"
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}
    >
      {title}
    </Typography>
}

export default TypoTitle